export default __webpack_public_path__ + "static/media/Alfan_Music_Logo_Design.973bd65a.svg";